import script from "./CheckboxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=b875e6fe&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b875e6fe"]])

export default __exports__